var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerGameTypeProBounty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.523A5.5 5.5 0 0113.477 7.5H14v1h-.523A5.499 5.499 0 018.5 13.476V14h-1v-.524A5.499 5.499 0 012.523 8.5H2v-1h.523A5.5 5.5 0 017.5 2.523V2h1v.523z",
    fill: "#D70A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4a4 4 0 110 8 4 4 0 010-8zm0 1a3 3 0 100 6 3 3 0 000-6z",
    fill: "#fff"
  })));
}
SvgPokerGameTypeProBounty.displayName = 'PokerGameTypeProBounty';
export default SvgPokerGameTypeProBounty;